import { render } from "./ColumnWidgetModal.vue?vue&type=template&id=e81e7fb4&scoped=true"
import script from "./ColumnWidgetModal.vue?vue&type=script&lang=ts"
export * from "./ColumnWidgetModal.vue?vue&type=script&lang=ts"

import "./ColumnWidgetModal.vue?vue&type=style&index=0&id=e81e7fb4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e81e7fb4"

export default script